import type {INotificationParamsV5} from "../ui/5.0/popup/NotificationV5";
import type {AppNotifications} from "../ui/notification/AppNotifications";
import type {INotificationParams} from "../ui/notification/Notification";

export function notify(notificationContainer: React.RefObject<AppNotifications>, params: INotificationParams | INotificationParamsV5) {
	return notificationContainer.current?.notify(params);
}
